<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ bankAccountTitle | translate }}
            </h1>

            <p class="subtitle-m">
                {{ bankAccountSubtitle1 | translate }}
            </p>
        </div>

        <form class="list" [formGroup]="formGroup">
            <div class="line" (click)="onClickIban()" id="ibanDiv">
                <label for="form-control" class="ibanInfo">{{ iban | translate }}</label>
                <input type="text" class="form-control" formControlName="iban" id="iban" #ibanClick name="iban" maxlength="30" (input)="onInputIban($event)" />
            </div>
            <div class="text-info">
                <i class="ri-information-line"></i>
                <span class="text-info-help">{{ infoIban | translate }}</span>
            </div>
        </form>

        <div class="actions">
            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>